module.exports = __webpack_public_path__ + "static/media/synth_19.48d8eaf8.mp3";